'use client'

import { useState } from 'react'
import { Button } from '@/components/ui/button'
import { CreditTopUpDialog } from '@/components/billing/credit-top-up-dialog'
import { CREDIT_PACK_MIN_CREDITS, creditPackPriceUsd } from '@/lib/credit-pack'

/** The same one-time purchase and return flow used by the workspace wallet. */
export function CreditPackOffer({
  returnUrls,
  disabled = false,
}: {
  returnUrls?: { successUrl: string; cancelUrl: string }
  disabled?: boolean
}) {
  const [open, setOpen] = useState(false)
  return (
    <div className="space-y-5 p-6 sm:p-8">
      <h2 className="text-xl font-semibold">Buy toolfare credits</h2>
      <p className="text-muted-foreground text-sm">
        Pay as you go. Buy credits when you need them, with no subscription.
        Credits are quoted before each call.
      </p>
      <p className="text-lg font-medium">
        {CREDIT_PACK_MIN_CREDITS.toLocaleString()} credits from $
        {creditPackPriceUsd(CREDIT_PACK_MIN_CREDITS)}
      </p>
      <Button disabled={disabled} onClick={() => setOpen(true)}>
        Buy credits
      </Button>
      {open && <CreditTopUpDialog open onOpenChange={setOpen} returnUrls={returnUrls} />}
    </div>
  )
}
